/**
 * useAuth — Auth context + types + consumer hook
 *
 * Split out of AuthContext.tsx (E.14, 2026-04-29) so that AuthContext.tsx
 * is component-only and Vite Fast Refresh works without
 * react-refresh/only-export-components warnings.
 *
 * AuthContext.tsx imports AuthContext + types from this file; consumers
 * import useAuth directly from this file.
 */
import { createContext, useContext } from 'react';
import { UserInfo } from '../services/authService';

export interface AuthState {
  user: UserInfo | null;
  token: string | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export interface AuthContextValue extends AuthState {
  login: (redirectPath?: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
